/**
 * Apply {{token}} placeholders — mirrors backend companyMailSettingsService.
 */
export function applyMailPlaceholders(template, vars = {}) {
  let s = String(template == null ? '' : template);
  for (const [key, val] of Object.entries(vars)) {
    s = s.split(`{{${key}}}`).join(val == null ? '' : String(val));
  }
  return s;
}

/** Demo values so preview matches a typical Form 12A send. */
export const MAIL_PREVIEW_SAMPLE_VARS = {
  building_name: 'Centro Building',
  building_address: '123 Queen Street, Auckland',
  ss_code: 'SS4',
  ss_name: 'Emergency Exit',
  ss_label: 'SS 4 Emergency Exit',
  paperwork_label: 'Form 12A',
  paperwork_type: 'FORM_12A',
  issued_date: '22 Sep 2026',
  iqp_name: 'J. Smith (IQP)',
  company_name: 'Cornerstone Building Service Ltd',
  company_email: 'admin@cbsl.co.nz',
  company_phone: '+64 9 000 0000',
  file_name: 'Form12A_SS4_Centro.pdf',
};

export function buildMailPreviewParts({
  subject = '',
  headerText = '',
  body = '',
  footerText = '',
  vars = MAIL_PREVIEW_SAMPLE_VARS,
  filled = true,
}) {
  const map = filled ? vars : null;
  const subj = map ? applyMailPlaceholders(subject, map) : subject;
  const header = map ? applyMailPlaceholders(headerText, map) : headerText;
  const main = map ? applyMailPlaceholders(body, map) : body;
  const footer = map ? applyMailPlaceholders(footerText, map) : footerText;
  const parts = [header, main, footer].map((p) => String(p || '').trim()).filter(Boolean);
  return {
    subject: subj,
    header,
    body: main,
    footer,
    fullText: parts.join('\n\n'),
  };
}
